import { createColumn, defaultColumns, inputTextField, relationField } from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'Description',
    field: 'description',
    component: inputTextField({ req: false, type: 'textarea', max: 255 })
  }),
  createColumn({
    label: 'Date',
    field: 'date',
    type: 'date',
    component: {
      is: 'q-datetime',
      props: {
        type: 'datetime',
        format24h: false,
        format: 'MMM DD YYYY h:mm a'
      },
      validation: {
        required: false
      }
    }
  }),
  createColumn({
    label: 'Amount',
    field: 'amount',
    type: 'number',
    component: inputTextField({ req: false, type: 'number', money: true })
  }),
  createColumn({
    label: 'Currency',
    field: 'currency',
    component: inputTextField({ req: false, max: 31 })
  }),
  createColumn({
    label: 'Purchase',
    field: 'purchase',
    ...relationField({
      validation: { required: false },
      type: 'one',
      localKey: 'purchaseId',
      fk: 'id',
      namespace: 'purchase',
      filterIs: 'text-filter'
      // label: 'amount'
    })
  }),
  createColumn({
    label: 'Payment Method',
    field: 'paymentMethod',
    ...relationField({
      props: { allowEdit: false, addButton: false },
      validation: { required: false },
      type: 'one',
      localKey: 'paymentMethodId',
      fk: 'id',
      namespace: 'paymentMethod',
      filterIs: 'text-filter'
      // label: 'name'
    })
  }),
  // createColumn({
  //   label: 'Quickbooks Invoice ID',
  //   field: 'qbInvoiceId',
  //   component: inputTextField({ req: false, type: 'textarea', max: 255 })
  // }),
  createColumn({
    label: 'Quickbooks Token',
    field: 'qbToken',
    component: inputTextField({ req: false, type: 'textarea' })
  }),
  createColumn({
    label: 'Quickbooks System Charge ID',
    field: 'qbSysChargeId',
    component: {
      is: 'quickbooks-sys-charge-id'
    }
    // component: inputTextField({ req: false, type: 'text', max: 255 })
  }),
  createColumn({
    label: 'Quickbooks System Refund ID',
    field: 'qbSysRefundId',
    component: inputTextField({ req: false, type: 'text', max: 255 })
  }),
  createColumn({
    label: 'Quickbooks System Created Date',
    field: 'qbSysCreated',
    type: 'date',
    component: {
      is: 'q-datetime',
      props: {
        type: 'datetime',
        format24h: false,
        format: 'MMM DD YYYY h:mm a'
      },
      validation: {
        required: false
      }
    }
  }),
  createColumn({
    label: 'Quickbooks System Status',
    field: 'qbSysStatus',
    component: inputTextField({ req: false, type: 'text', max: 255 })
  }),
  createColumn({
    label: 'Quickbooks System Auth Code',
    field: 'qbSysAuthCode',
    component: inputTextField({ req: false, type: 'text', max: 255 })
  })
  // createColumn({
  //   label: 'Quickbooks System Capture Detail',
  //   field: 'qbSysCaptureDetail',
  //   component: inputTextField({ req: false, type: 'textarea', max: 255 })
  // })
].concat(defaultColumns)
